import React from "react";
import { SocialIcon } from "react-social-icons";

const Contact=()=>{
	
	return(

<div id="chat-with-us">
<h3>Chat With Us</h3>
<section id="contact-footer">
  <a href="https://www.linkedin.com/company/beast-o/" target="_blank" rel="noopener noreferrer">
      <SocialIcon network="linkedin" />
      </a>
   <a href="https://www.facebook.com/Beast-O-Tech-105034718988710" target="_blank" rel="noopener noreferrer">
      <SocialIcon network="facebook" />
      </a>
         <a href="https://twitter.com/beast_o_tech" target="_blank" rel="noopener noreferrer">

      <SocialIcon network="twitter" />
      </a>
      <a
        href="https://wa.me/+27617397276"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        <SocialIcon network="whatsapp" />
      </a>
      <a
        href="mailto:enquiries@beast-o.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <SocialIcon network="email" bgColor="white" />
      </a>
      </section>
</div>
	)
}
export default Contact;